import { render } from "./OrderItemView.vue?vue&type=template&id=28de88fc&ts=true"
import script from "./OrderItemView.vue?vue&type=script&lang=ts"
export * from "./OrderItemView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__